var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.31 15.9C17.75 15.21 18 14.38 18 13.5C18 11 16 9 13.5 9C11 9 9 11 9 13.5C9 16 11 18 13.5 18C14.37 18 15.19 17.75 15.88 17.32L19 20.39L20.39 19L17.31 15.9ZM13.5 16C12.837 16 12.2011 15.7366 11.7322 15.2678C11.2634 14.7989 11 14.163 11 13.5C11 12.837 11.2634 12.2011 11.7322 11.7322C12.2011 11.2634 12.837 11 13.5 11C14.163 11 14.7989 11.2634 15.2678 11.7322C15.7366 12.2011 16 12.837 16 13.5C16 14.163 15.7366 14.7989 15.2678 15.2678C14.7989 15.7366 14.163 16 13.5 16ZM3 17V9H0L10 0L20 9H18.18C17 7.77 15.34 7 13.5 7C9.92 7 7 9.92 7 13.5C7 14.79 7.38 16 8.03 17H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSearch);
export default __webpack_public_path__ + "static/media/house-search.ddd187a9d0ca17d6719b31ce83d540a2.svg";
export { ForwardRef as ReactComponent };